exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sidebar[data-v-c8c1dd9c]{overflow-y:auto;border-right:1px solid #5a5b54\n}\n.horizontal-separator[data-v-c8c1dd9c]{margin:0;padding:0;border-bottom:1px solid #5a5b54\n}\n.text-xsmall-bold[data-v-c8c1dd9c]{font-size:x-small;font-weight:bold\n}\n", ""]);

// exports
